import React, { useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaCrosshairs, FaGem } from "react-icons/fa6";
import { IoEyeSharp } from "react-icons/io5";
import "./MissionVision.css"; // Importing the updated scoped stylesheet
import { Link } from "react-router-dom";
import { getVisionandMission } from "../../../features/home/homeSlice";
import { useDispatch, useSelector } from "react-redux";

const MissionVision = () => {

  const dispatch = useDispatch();
  const visionandmission = useSelector((state) => state.home.visionandmission);

  useEffect(() => {
    dispatch(getVisionandMission());
  }, [dispatch]);

  // console.log(visionandmission," visionandmission")

  return (
    <section className="mission-vision-section">
      <Container>
        {/* Header Row */}
        <Row className="align-items-end mb-3">
          <Col md={9}>
            <span className="text-muted text-uppercase fw-semibold sub-title">
              About Us
            </span>
            <h2 className="heading_text">Our  Vision ,  Mission & Core Values</h2>
          </Col>
          <Col md={3} className="text-md-end text-start mt-3 mt-md-0">
            <Link to={"/about-us"}>
              <Button className="btn-read-more border-0 px-4 py-2 text-uppercase fw-bold">
                Read More
              </Button>
            </Link>
          </Col>
        </Row>

        {/* Cards Row */}
        <Row className="g-4 justify-content-center">


          {/* Vision Card */}
          <Row>
            {visionandmission?.map((item, index) => (
              <Col lg={4} md={6} sm={6} key={index}>
                <div className="km-card text-center h-100">
                  <div className="icon_img_holder">
                    <img
                      src={process.env.REACT_APP_IMG_URL + item?.image}
                      alt={item?.name}
                      className="icon_img"
                    />
                  </div>

                  <h4 className="card-title fw-bold">{item?.name}</h4>

                  <p className="card-text text-muted">
                    {item?.subname}
                  </p>
                </div>
              </Col>
            ))}
          </Row>



          {/* <Col lg={4} md={6} sm={6}>
            <div className="km-card text-center h-100 ">
              <div className="icon_img_holder">
                <img src="/assets/images/home/MissionVision/vission.png" alt="icon" className="icon_img" />
              </div>
              <h4 className="card-title fw-bold">Vision</h4>
              <p className="card-text text-muted">
                To foster innovation, drive sustainable growth, and create
                long-term value for our customers, employees, and communities.
              </p>
            </div>
          </Col> */}

          {/* Mission Card */}
          {/* <Col lg={4} md={6} sm={6}>
            <div className="km-card text-center h-100 p-4">
              <div className="icon_img_holder">
                <img src="/assets/images/home/MissionVision/mission.png" alt="icon" className="icon_img" />
              </div>
              <h4 className="card-title fw-bold">Mission</h4>
              <p className="card-text text-muted">
                Our mission is to deliver innovative CCTV solutions that improve
                safety and peace of mind with integrity and excellence.
              </p>
            </div>
          </Col> */}

          {/* Core Value Card */}
          {/* <Col lg={4} md={6} sm={6}>
            <div className="km-card text-center h-100 p-4">
              <div className="icon_img_holder">
                <img src="/assets/images/home/MissionVision/values.png" alt="icon" className="icon_img" />
              </div>
              <h4 className="card-title fw-bold">Core Value</h4>
              <p className="card-text text-muted">
                Our Core values—Integrity, Innovation, Excellence, and
                Collaboration—drive us to provide trustworthy, innovative
                security
              </p>
            </div>
          </Col> */}


        </Row>
      </Container>
    </section>
  );
};

export default MissionVision;
